import { IDataColumnDefProps, ITextQuery } from "@plex/react-components";

export interface IPickerSearchCriterion<T> {
  query: ITextQuery;
  searchedColumns: Array<IDataColumnDefProps<T>>;
}

export const applyPickerFilter = <T>(rows: T[], criterion: IPickerSearchCriterion<T>, defaultValueFn: (row: T) => string | undefined) => {
  const defaultFilter = (source: string, searchedString: string) => {
    return source.toLowerCase().includes(searchedString.toLowerCase());
  };

  const { query, searchedColumns } = { ...criterion };

  if (query.query) {
    if (searchedColumns.length === 0) {
      return rows.filter(row => defaultFilter(defaultValueFn(row) || "", query.query));
    } else {
      return rows.filter(row =>
        query.isMatch(
          searchedColumns.map(col => {
            if (col.valueSelector) {
              const value = col.valueSelector?.(row);

              return value ? String(value) : "";
            }

            return "";
          })
        )
      );
    }
  }
  return rows;
};
